import { ReactNode } from "react";

export const DefaultOverride = ({ children }: { children?: ReactNode }) => (
  <>{children}</>
);
